import React from 'react';

import WidgetIcons from '../../assets/WidgetIcons';

const getWidgetIcon = (widgetType) => {
    const widgetIcon = WidgetIcons[widgetType];

    if (!widgetIcon) return widgetType;

    return widgetIcon();
};

const ImageButtons = (props) => {
    const { widget, options, field, setWidgetFieldValue } = props;

    let chosenText = '';
    const available = _.filter((options), (o) => 
        o.availability.includes(widget.dataType) && o.divideAvailability.includes(widget.dataConfig.dividedBy));
    const imageButtons = available.map((o, index) => {
        let className = 'displayTypeBtn available';

        if (widget.displayType === o.value) {
            className += ' selected';
            chosenText = o.title;
        }

        return (
            <div
                className={className}
                onClick={setWidgetFieldValue.bind(null, field, o.value)}
                key={index}
            >
                <p>{getWidgetIcon(o.value)}</p>
            </div>
        );  
    });

    return (
        <div className="settingsRow" style={{ gridTemplateColumns: `repeat(${available.length}, 1fr)`, height: '78px'}}>
            {imageButtons}
        </div>
    );
};


ImageButtons.propTypes = {
    widget: React.PropTypes.object,
    options: React.PropTypes.array,
    field: React.PropTypes.string,
    setWidgetFieldValue: React.PropTypes.func,
};

export default ImageButtons;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/ImageButtons.jsx
 **/